import { Routes, Route } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import ProjectsPage from "./pages/ProjectsPage";
import Navbar from "./components/common/Navbar";
import ScrollToTopButton from "./components/ScrollToTopButton";
import FooterSection from "./components/common/Footer";
import { ThemeProvider } from "./ThemeContext";
import SkillsPage from "./pages/SkillsPage";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <ThemeProvider>
      <div className="unselectable">
        <Toaster />
        <Navbar />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/skills" element={<SkillsPage />} />
        </Routes>
        <FooterSection />
        <ScrollToTopButton />
      </div>
    </ThemeProvider>
  );
}

export default App;
